import { RouteType } from "types/RouteType";
import ManholeSalesDashboardRoute from "./ManholeSalesDashboard/ManholeSalesDashboard.Route";

const salesRoutesList: RouteType[] = [
  ManholeSalesDashboardRoute,
];

export default salesRoutesList;
